import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AttachmentsViewModel } from 'src/app/models/item.model';
import { ImageSelectedEventPayload } from '../../models/event-payloads.model';
import { AttachmentCollageComponent } from '../attachment-collage/attachment-collage.component';
import { AttachmentImageColumnComponent } from '../attachment-image-column/attachment-image-column.component';
import { DocumentAttachmentComponent } from '../document-attachment/document-attachment.component';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AttachmentCollageComponent, AttachmentImageColumnComponent, DocumentAttachmentComponent]
})
export class AttachmentsComponent {
  @Input() attachments: AttachmentsViewModel;
  @Input() useImageColumn: boolean;
  @Output() openAttachment = new EventEmitter<string>();
  @Output() imageSelected = new EventEmitter<ImageSelectedEventPayload>();
  @Output() getThumb = new EventEmitter<string>();
  @Output() getFull = new EventEmitter<string>();
}
